import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import './flashcard_home.css';

// # Import chapter icons from library
import anatomyIcon from '../../../general/library/step1/step1_icons/anatomy.png';
import biochemistryIcon from '../../../general/library/step1/step1_icons/biochemistry.png';
import bloodIcon from '../../../general/library/step1/step1_icons/blood.png';
import cnsIcon from '../../../general/library/step1/step1_icons/cns.png';
import endocrineIcon from '../../../general/library/step1/step1_icons/endocrine.png';
import eyeIcon from '../../../general/library/step1/step1_icons/eye.png';
import gitIcon from '../../../general/library/step1/step1_icons/git.png';
import heartIcon from '../../../general/library/step1/step1_icons/heart.png';
import immunologyIcon from '../../../general/library/step1/step1_icons/immunology.png';
import infectiousIcon from '../../../general/library/step1/step1_icons/infectious.png';
import kidneyIcon from '../../../general/library/step1/step1_icons/kidney.png';
import lungsIcon from '../../../general/library/step1/step1_icons/lungs.png';
import musculoskeletalIcon from '../../../general/library/step1/step1_icons/musculoskeletal.png';
import pathologyIcon from '../../../general/library/step1/step1_icons/pathology.png';
import pharmaIcon from '../../../general/library/step1/step1_icons/pharma.png';
import psychiatryIcon from '../../../general/library/step1/step1_icons/psychiatry.png';
import publicHealthIcon from '../../../general/library/step1/step1_icons/public_health.png';
import reproductiveIcon from '../../../general/library/step1/step1_icons/reproductive-system.png';
import revisionIcon from '../../../general/library/step1/step1_icons/revision.png';
import skinIcon from '../../../general/library/step1/step1_icons/skin.png';

function FlashcardHome({ isDarkMode, steps }) {
  const navigate = useNavigate();
  const [expandedDecks, setExpandedDecks] = useState({});

  // # Chapter data mapping
  const chapterIcons = {
    'Biochemistry': biochemistryIcon,
    'Immunology': immunologyIcon,
    'Microbiology': infectiousIcon,
    'General Pathology': pathologyIcon,
    'Pharmacology': pharmaIcon,
    'Public Health Sciences': publicHealthIcon,
    'Anatomy & Histology': anatomyIcon,
    'Cardiovascular': heartIcon,
    'Endocrine': endocrineIcon,
    'Gastrointestinal': gitIcon,
    'Hematology & Oncology': bloodIcon,
    'Musculoskeletal & Connective Tissue': musculoskeletalIcon,
    'Dermatology': skinIcon,
    'Neurology': cnsIcon,
    'Special Senses': eyeIcon,
    'Psychiatry': psychiatryIcon,
    'Renal': kidneyIcon,
    'Reproductive': reproductiveIcon,
    'Respiratory': lungsIcon,
    'Rapid Review': revisionIcon
  };

  // # Toggle deck expansion
  const toggleDeck = (deckId) => {
    setExpandedDecks(prev => ({
      ...prev,
      [deckId]: !prev[deckId]
    }));
  };

  // # Handle new card creation
  const handleAddCard = (e, deckId, chapterId = null) => {
    e.stopPropagation();
    const basePath = '/flashcards';
    navigate(`${basePath}/create/${deckId}${chapterId ? `/${chapterId}` : ''}`);
  };

  // # Handle deck/chapter click
  const handleClick = (deckId, chapterId = null) => {
    const basePath = '/flashcards';
    navigate(`${basePath}/preview/${deckId}${chapterId ? `/${chapterId}` : ''}`);
  };

  return (
    <div className="flsh_hm_content">
      {steps.map((step) => (
        <div key={step.id} className="flsh_hm_deck">
          <div className="flsh_hm_deck-header" onClick={() => toggleDeck(step.id)}>
            <div className="flsh_hm_deck-title">
              <img src={step.icon} alt={step.title} className="flsh_hm_deck-icon" />
              <div>
                <h2>{step.title}</h2>
                <p>{step.description}</p>
              </div>
            </div>
            <div className="flsh_hm_deck-actions">
              <button 
                className="flsh_hm_add-button"
                onClick={(e) => handleAddCard(e, step.id)}
              >
                <FaPlus />
              </button>
              <span className={`flsh_hm_collapse-arrow ${expandedDecks[step.id] ? 'expanded' : ''}`}>
                ▼
              </span>
            </div>
          </div>

          {expandedDecks[step.id] && (
            <div className="flsh_hm_chapters-grid">
              {Object.entries(chapterIcons).map(([title, icon]) => (
                <div 
                  key={title}
                  className="flsh_hm_chapter-card"
                  onClick={() => handleClick(step.id, title.toLowerCase().replace(/\s+/g, '_'))}
                >
                  <div className="flsh_hm_chapter-header">
                    <img src={icon} alt={title} className="flsh_hm_chapter-icon" />
                    <button 
                      className="flsh_hm_add-button flsh_hm_add-button-small"
                      onClick={(e) => handleAddCard(e, step.id, title.toLowerCase().replace(/\s+/g, '_'))}
                    >
                      <FaPlus />
                    </button>
                  </div>
                  <h3>{title}</h3>
                  <div className="flsh_hm_chapter-stats">
                    <span>0 cards</span>
                    <span>0% complete</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FlashcardHome; 